import React from "react";
import { Text } from "@foris/avocado-suite";
import { ProgrammingStructure } from "@models/ISchema";
import Modal from "@components/modal";
import { useTranslation } from "react-i18next";

interface DeleteStructureModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  programmingStructure?: ProgrammingStructure;
}

const DeleteStructureModal = ({
  isOpen,
  onClose,
  onDelete,
  programmingStructure,
}: DeleteStructureModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      typeState="confirm"
      show={isOpen}
      title={t("programming-structures.modals.delete-structure.title")}
      textButtonPrincipal={t("programming-structures.modals.delete-structure.delete")}
      textButtonSecondary={t("generals.cancel")}
      onClose={onClose}
      onClickPrincipal={onDelete}
      onClickSecondary={onClose}
    >
      <Text>
        {t("programming-structures.modals.delete-structure.description", {
          code: programmingStructure?.code,
          name: programmingStructure?.name,
        })}
      </Text>
    </Modal>
  );
};

export default DeleteStructureModal;
